module.exports = "pegasus_template/assets/blocks/capture-7-basic.png";